/* ==========================================================================
   footer.js — FOOTER (For.me)
   --------------------------------------------------------------------------
   À CHARGER dans theme.liquid :
     <script src="{{ 'footer.js' | asset_url }}" defer></script>

   Pour l'instant : squelette prêt. Le fond dégradé est géré en CSS
   (footer.css). Dis-moi quel comportement dynamique tu veux ici
   (ex. accordéons "un seul ouvert à la fois", année du copyright auto,
   apparition au scroll…) et je le remplis.
   ========================================================================== */
(function () {
  'use strict';

  var footer = document.querySelector('footer .shopify-section-group-footer-group')
            || document.querySelector('footer');
  if (!footer) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* --- Emplacement pour la logique footer à venir --- */
  });
})();